import React from 'react';
import { Form } from '@dashboard/components/Formik';
import usePage from '@dashboard/hooks/usePage';

const RegistrationLimitsForm = () => {
  const { page, updatePage } = usePage();

  return (
    <Form
      initialValues={{
        limitRegistrations: {
          enabled: page.eventDetails?.limitRegistrations?.enabled,
        },
      }}
      fields={() => [
        {
          name: 'limitRegistrations.enabled',
          required: false,
          type: 'checkbox',
          label: 'Prevent repeat registrations',
          helpText: 'Limit each guest to one registration for this event.',
        },
      ]}
      onSubmit={async (values, actions) => {
        const limitRegistrations = { enabled: values.limitRegistrations?.enabled === true };

        const { data, error } = await updatePage.mutateAsync({
          eventDetails: {
            ...page.eventDetails,
            limitRegistrations,
          },
        });

        if (data) {
          actions.resetForm({ values: { limitRegistrations } });
        }

        return { data, error };
      }}
    />
  );
};

export default RegistrationLimitsForm;
